import { HomeSections, defaultHomeContent } from "@quintara/site-kit";
import { usePageMeta } from "../usePageMeta";
import { useCmsContent } from "../useCmsContent";

// Markup lives in @quintara/site-kit's HomeSections, driven by content fetched
// from the CMS at runtime (defaultHomeContent until it loads / if it fails).
// The react-router <Link> adapter is provided once in Layout.
export function Home() {
  const content = useCmsContent("home", defaultHomeContent);
  usePageMeta(content.meta.title, content.meta.description);
  return <HomeSections content={content} />;
}
